module.exports = __webpack_public_path__ + "static/media/chocolate-cream-nutrition.f41acf20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/chocolate-cream-nutrition.jpg
// module id = 179
// module chunks = 0